/**
 * Type definitions and constants for License Management
 */

// Re-export ViewMode from Tabs for consistency
export type { ViewMode } from '../components/Dashboard/Tabs/type';

import type { License } from '../components/Dashboard/LicenseInventory/type';

export type { License };

// Define additional types needed by the feature
export type DashboardMetrics = Record<string, unknown>;

export interface LicenseSnapshot {
  id: string;
  vendor: string;
  status: string;
  metrics: {
    totalSpend: number;
    utilization: number;
    costPerEmployee: number;
    optimizationScore: number;
    riskAlerts: number;
  };
  skus: {
    name: string;
    expiryDate: string;
  }[];
  userRoles: {
    role: string;
    count: number;
  }[];
  findings: string[];
}

export interface DashboardState {
  selectedLicense: License | null;
  filters?: Record<string, unknown>;
  sortBy?: string;
  sortOrder?: 'asc' | 'desc';
  metrics?: DashboardMetrics;
  licenses?: License[];
}

export const VIEW_MODES = {
  GRAPHICAL: 'graphical',
  LIST: 'list',
} as const;

export const SORT_OPTIONS = {
  ANNUAL_COST: 'By Annual Cost',
  UTILIZATION: 'By Utilization',
} as const;

export type SortOption = (typeof SORT_OPTIONS)[keyof typeof SORT_OPTIONS];
